export const topRankBundle = {
  usage: { ko: "사용량", en: "Usage", es: "Uso" },
  dong: { ko: "{dong}동", en: "Building {dong}", es: "Edificio {dong}" }
}
